import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';

const service = axios.create({
  baseURL: '/api',
  timeout: 30000
});

// 请求拦截：注入上下文请求头（对接后端 RequestContext）
service.interceptors.request.use(
  (config) => {
    const projectId = store.state.currentProjectId;
    if (projectId) {
      config.headers['X-Project-Id'] = projectId;
    }
    // 开发阶段：固定用户。生产替换为 JWT。
    config.headers['X-User-Id'] = store.state.userId || '1';
    config.headers['X-User-Name'] = store.state.userName || 'admin';
    config.headers['X-Group-Level'] = String(store.state.groupLevel !== false);
    config.headers['X-Group-Id'] = store.state.groupId || '1';
    config.headers['X-Dept-Id'] = store.state.deptId || '1';
    config.headers['X-Scoped-Depts'] = store.state.deptId || '1';
    if (store.state.currentDataScope) {
      config.headers['X-Data-Scope'] = store.state.currentDataScope;
    }
    if (store.state.currentRoleId) {
      config.headers['X-Role-Id'] = store.state.currentRoleId;
    }
    if (store.state.currentRoleCode) {
      config.headers['X-Role-Code'] = store.state.currentRoleCode;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截：统一处理 { code, msg, data }
service.interceptors.response.use(
  (response) => {
    // 文件下载（blob）直接返回
    if (response.config.responseType === 'blob') {
      return response;
    }
    const res = response.data;
    if (res.code === 0 || res.success) {
      // 分页数据的 total/current/size 可能被后端序列化为字符串，转回数字
      if (res.data && res.data.total !== undefined) {
        res.data.total = Number(res.data.total);
        res.data.current = Number(res.data.current);
        res.data.size = Number(res.data.size);
      }
      return res.data;
    }
    Message.error(res.msg || '操作失败');
    return Promise.reject(new Error(res.msg || 'Error'));
  },
  (error) => {
    if (!(error.config && error.config.silent)) {
      const msg = error.response && error.response.data && error.response.data.msg
        ? error.response.data.msg
        : error.message;
      Message.error(msg || '网络错误');
    }
    return Promise.reject(error);
  }
);

export default service;
